import { ObjectMeta } from "@supernova-studio/model";
import { DTOThemeOverride } from "./override";
import { z } from "zod";
//
// Read
//
export const DTOThemesListQuery = z.object({
    brandId: z.string().optional(),
});
export const DTOTheme = z.object({
    id: z.string(),
    persistentId: z.string(),
    designSystemVersionId: z.string(),
    brandId: z.string(),
    meta: ObjectMeta,
    codeName: z.string(),
    parentPersistentId: z.string().optional(),
    collectionPersistentIds: z.string().array(),
    overrides: DTOThemeOverride.array(),
});
export const DTOThemeResponse = z.object({
    theme: DTOTheme,
});
export const DTOThemeListResponse = z.object({
    themes: DTOTheme.array(),
});
//
// Write
//
export const DTOThemeCreatePayload = z.object({
    meta: ObjectMeta,
    persistentId: z.string(),
    brandId: z.string(),
    codeName: z.string(),
    overrides: DTOThemeOverride.array(),
});
